export default function tier4CardWidget() {
  const widgetName = 'tier4CardWidget';
  const widgetOpts = tier4CardWidgetOpts;
  const $widget = $(`#${widgetName}`);

  return new Promise((resolve) => {
    return saffire.widgets.cardWidget($($widget), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      showDescription: true,
      hasImages: false,
      lazyLoadImages: false,
      imageIsBackground: false,
      textOverImage: false,
      itemsPerPanel: 1,
      maxItemsVisible: 1,

      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData) {
          createCustomCardWidget(data.items);
          resolve(true);
        } else {
          $widget.remove();
          resolve(false);
        }
      },
    });
  });

  function createCustomCardWidget(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description } = widgetData[0];

    $seo.replaceWith(`
        <h2 class="card-title">${Title}</h2>
        <div class="card-description">${Description}</div>
    `);
  }
}
